<div class="row">
    <div class="col-6">
        <jhi-collapsible customClass="d-inline-flex p-2 h5 fw-bold" heading="{{ 'study-editor.study-settings.define-settings' | translate }}"
                         iconClass="bms-icon bms-mgt-details"
                         [helpKey]="HELP_MANAGE_STUDIES_SETTINGS">
            @if (studySettings) {
                <jhi-variables-table [variables]="studySettings"
                                     [showInputVariablesColumn]="false"
                                     (onAddEvent)="addVariable($event)"
                                     (onRemoveEvent)="detachOrDeleteFilesIfAny($event)"
                                     [variableTypeIds]="[VariableTypeEnum.STUDY_DETAIL]"
                                     [hiddenVariablesFromTable]="HIDE_FROM_TABLE"
                                     [hiddenVariablesFromSelector]="HIDE_FROM_VARIABLE_SELECTOR"
                                     [disableVariablesFromSelector]="studyEditorContext.existingEnvironmentLevelVariableIds"
                                     [showReorderButtons]="false"
                                     [showAddButton]="principal.hasAnyAuthorityDirect(ADD_STUDY_SETTINGS_VARIABLES_PERMISSIONS)"
                                     [showDeleteButton]="principal.hasAnyAuthorityDirect(ADD_STUDY_SETTINGS_VARIABLES_PERMISSIONS)">
                </jhi-variables-table>
            }
        </jhi-collapsible>
    </div>
</div>
<div class="row pt-3">
    <div class="col-12 d-flex justify-content-end">
        @if (isFileStorageConfigured) {
            <button (click)="showFiles()"
                    class="btn btn-info btn-sm">{{ 'study-editor.study-settings.add-files' | translate }}
            </button>
        }
    </div>
</div>
<div class="row pt-3">
    <div class="col-12">
        <div class="custom-scroll-style" style="min-height: 500px; max-height: 500px; overflow-y: auto; overflow-x: auto;">
            <table id="study-settings-table" class="table table-striped table-bordered table-curved table-editable">
                <thead class="sticky-header">
                <tr>
                    @if (isFileStorageConfigured) {
                        <th style="width: 25px">{{ 'study-editor.study-settings.table.files' | translate }}</th>
                    }
                    <th style="width: 40%;">{{ 'study-editor.study-settings.table.variable-name' | translate }}</th>
                    <th [class.editable]="principal.hasAnyAuthorityDirect(MODIFY_STUDY_SETTINGS_VALUES_PERMISSIONS)"
                        style="width: 60%">{{ 'study-editor.study-settings.table.value' | translate }}
                    </th>
                </tr>
                </thead>
                <tbody>
                    @if (filteredStudySettings?.length) {
                        @for (studySetting of filteredStudySettings; track trackId(studySetting); let rowIndex = $index) {
                            <tr (mouseenter)="setHoveredRow(rowIndex)"
                                (mouseleave)="setHoveredRow(null)">
                                @if (isFileStorageConfigured) {
                                    <td>
                                        @if (isFileButtonVisible(studySetting)) {
                                            <button class="btn btn-sm btn-outline-info"
                                                    title="{{ 'file.manager.open.title' | translate }}"
                                                    (click)="showFiles(studySetting)"><i class="fa fa-file"></i></button>
                                        } @else if (hoveredRow === rowIndex) {
                                            <button class="btn btn-sm btn-outline-info"
                                                    title="{{ 'file.manager.open.title' | translate }}"
                                                    (click)="showFiles(studySetting)"><i class="fa fa-file"></i></button>
                                        }
                                    </td>
                                }
                                <td>{{ studySetting.alias || studySetting.name }}</td>
                                @if (!principal.hasAnyAuthorityDirect(MODIFY_STUDY_SETTINGS_VALUES_PERMISSIONS)) {
                                    <td>{{ studySetting.value | categoricalDisplayValue:studySetting:'id':false }}</td>
                                } @else {
                                    <td class="text-wrap"
                                        [class.editable]="principal.hasAnyAuthorityDirect(MODIFY_STUDY_SETTINGS_VALUES_PERMISSIONS)"
                                        [class.selected]="selectedCell?.row === rowIndex && selectedCell?.col === 3"
                                        [class.number-cell]="variableDataTypeIs(studySetting, DataTypeEnum.NUMERIC)"
                                        [class.date-cell]="variableDataTypeIs(studySetting, DataTypeEnum.DATE)"
                                        [class.categorical-cell]="variableDataTypeIs(studySetting, DataTypeEnum.CATEGORICAL)"
                                        (click)="selectCell(studySetting, rowIndex, 3)">
                                        @if (!studySetting.isEditing) {
                                            {{ studySetting.value | categoricalDisplayValue:studySetting:'id':'description_only' }}
                                        } @else {
                                            <jhi-study-settings-inline-editor
                                                    [studySettingVariable]="studySetting"
                                                    (onBlur)="onCellBlur(rowIndex, 3)"
                                                    (onKeyDown)="onCellKeyDown($event, rowIndex, 3)">
                                            </jhi-study-settings-inline-editor>
                                        }
                                    </td>
                                }

                            </tr>
                        }
                    } @else {
                        <tr>
                            <td [attr.colspan]="isFileStorageConfigured ? 3 : 2" class="text-center py-3">
                                {{ 'study-editor.no-records' | translate }}
                            </td>
                        </tr>
                    }
                </tbody>
            </table>
        </div>
    </div>
</div>
